/*
 * Business / individual price toggle (replaces the T-Selector app).
 *
 * Shopify prices are stored excl. VAT. Business (default) shows them as stored; individual
 * multiplies every price inside .tax-price (and bare <sale-price>) by 1 + rate / 100.
 * Config comes from snippets/vat-switch.liquid (window.ergoVat). Prices re-rendered by the theme
 * (variant change, cart drawer, filters) are picked up by a MutationObserver.
 */
(() => {
  const config = window.ergoVat;
  if (!config) return;

  const STORAGE_KEY = 'ergo-vat-mode';
  // Integer per-mille (25.5 % -> 1255) so cents * 1255 / 1000 rounds exactly: 22900 * 1.255 in
  // floating point is 28739.4999… and would round down to €287,39 instead of €287,40.
  const VAT_PER_MILLE = Math.round((100 + config.rate) * 10);
  // A money amount as the theme prints it: "€1.234,56 EUR", "3 731,00 SEK", "329,00 kr"
  const MONEY = /(€\s?)?(\d{1,3}(?:[.\s  ]\d{3})+|\d+)[,.](\d{2})(?:\s?(?:EUR|SEK|kr))?/g;

  const original = new WeakMap(); // element -> innerHTML before conversion
  const rendered = new WeakMap(); // element -> innerHTML we last wrote

  let mode = 'b2b';
  try {
    if (localStorage.getItem(STORAGE_KEY) === 'b2c') mode = 'b2c';
  } catch (e) {}

  function formatMoney(cents) {
    const format = config.moneyFormat || '€{{amount_with_comma_separator}}';
    // decimal === null drops the decimals (amount_no_decimals formats)
    const group = (thousands, decimal) => {
      const [whole, fraction] = (decimal === null ? Math.round(cents / 100).toString() : (cents / 100).toFixed(2)).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
      switch (placeholder) {
        case 'amount_with_comma_separator': return group('.', ',');
        case 'amount_with_space_separator': return group(' ', ',');
        case 'amount_with_period_and_space_separator': return group(' ', '.');
        case 'amount_no_decimals': return group(',', null);
        case 'amount_no_decimals_with_comma_separator': return group('.', null);
        default: return group(',', '.');
      }
    });
  }

  function convertHtml(html, perMille) {
    const template = document.createElement('template');
    template.innerHTML = html;
    const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      node.nodeValue = node.nodeValue.replace(MONEY, (match, euro, whole, fraction) => {
        const cents = parseInt(whole.replace(/\D/g, '') + fraction, 10);
        return formatMoney(Math.round((cents * perMille) / 1000));
      });
    }
    return template.innerHTML;
  }

  function priceElements(root) {
    const elements = [...root.querySelectorAll('.tax-price')];
    root.querySelectorAll('sale-price').forEach((salePrice) => {
      if (!salePrice.querySelector('.tax-price')) elements.push(salePrice);
    });
    return elements;
  }

  function updatePrice(element) {
    if (original.get(element) === undefined || element.innerHTML !== rendered.get(element)) {
      original.set(element, element.innerHTML); // first visit, or the theme re-rendered it
    }
    const exempt = element.closest('[data-vat-exempt]');
    const perMille = mode === 'b2c' && !exempt ? VAT_PER_MILLE : 1000;
    const html = convertHtml(original.get(element), perMille);
    if (element.innerHTML !== html) element.innerHTML = html;
    rendered.set(element, element.innerHTML);
  }

  function updateHelper(priceList) {
    const salePrice = priceList.querySelector('sale-price');
    if (!salePrice) return;
    let helper = priceList.querySelector(':scope > .tax-price-helper');
    if (!helper) {
      helper = document.createElement('span');
      helper.className = 'tax-price-helper';
      salePrice.after(helper);
    }
    const text = `(${priceList.hasAttribute('data-vat-exempt') ? config.helper.b2b : config.helper[mode]})`;
    if (helper.textContent !== text) helper.textContent = text;
  }

  function updateSwitches() {
    document.querySelectorAll('[data-vat-switch]').forEach((vatSwitch) => {
      vatSwitch.querySelectorAll('[data-vat-mode]').forEach((side) => {
        side.classList.toggle('is-active', side.dataset.vatMode === mode);
      });
      vatSwitch.querySelector('[data-vat-toggle]').setAttribute('aria-checked', String(mode === 'b2c'));
    });
  }

  function updateAll() {
    priceElements(document).forEach(updatePrice);
    document.querySelectorAll('price-list').forEach(updateHelper);
    updateSwitches();
  }

  function setMode(newMode) {
    mode = newMode;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
    updateAll();
  }

  document.addEventListener('click', (event) => {
    const side = event.target.closest('[data-vat-switch] [data-vat-mode]');
    if (side) return setMode(side.dataset.vatMode);
    if (event.target.closest('[data-vat-switch] [data-vat-toggle]')) setMode(mode === 'b2c' ? 'b2b' : 'b2c');
  });

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  updateAll();
})();
